import gql from 'graphql-tag'

export const MEDICAL_IMAGE_FIELDS = gql`
  fragment medical_images_fields on medical_images {
    id
    aws_s3_url
  }
`
